import React, { useState, useEffect } from "react";
import { styled } from '@mui/material/styles';
import heroStyles from './HeroStyles';
import dryVanVideo from '../../videos/gm-final-video.mp4';
import Button from "../Button/Button";

type HeroProps = {

};

const StyledHero = styled('div')(({ theme }) => heroStyles());

const Hero: React.FC<HeroProps> = () => {
  const [ scrolled, setScrolled ] = useState(['', '', '', '']);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    setTimeout(() => {
      setScrolled(['animate__fadeInUp', '', '', '']);
    }, 400)
    setTimeout(() => {
      setScrolled(['animate__fadeInUp', 'animate__fadeInUp', '', '']);
    }, 700)
    setTimeout(() => {
      setScrolled(['animate__fadeInUp', 'animate__fadeInUp', 'animate__fadeInUp', '']);
    }, 1000)
    setTimeout(() => {
      setScrolled(['animate__fadeInUp', 'animate__fadeInUp', 'animate__fadeInUp', 'animate__fadeInUp']);
    }, 1200)
  }, []);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  const isMobile = width <= 1024;

  return (
    <StyledHero>
        <img className="hero-video" src="https://grupogm-assets.s3.us-east-1.amazonaws.com/grupo-gm-hero-background.webp"></img>
      
      <div className="hero-container">
        <div className="hero-text">
          <h1 className={`hero-seo `}>RENTA DE EQUIPO DE TRANSPORTE</h1>
          <h2 className={`hero-title `}>
            <span>RESPALDANDO LA </span><br/><span className="hero-highlighted-text"> LOGISTICA</span><span> DE TU EMPRESA</span>
          </h2>
          <h3 className={`hero-subtitle `}>
            En Grupo GM ofrecemos soluciones profesionales para transporte de carga. Más de 50 equipos disponibles para renta inmediata en Hidalgo y alrededores.
          </h3>
          <Button href="/renta-cajas-secas-hidalgo" className={``}>
            Ver equipos disponibles
          </Button>  
        </div>
      </div>
    </StyledHero>
  );
};

export default Hero;